const data = [
    {
        id: 1,
        name: "Dina Glenn",
        contact: "+821091519002",
        orderCount: 3,
    },
    {
        id: 2,
        name: "Ekaterina Tankova",
        contact: "+821091519002",
        orderCount: 3,
    },
    {
        id: 3,
        name: "Nicolina Lindholm",
        contact: "+821091519002",
        orderCount: 3,
    },
    {
        id: 4,
        name: "Tum Tantasatityanon",
        contact: "+821091519002",
        orderCount: 3,
    },
    {
        id: 5,
        name: "Débora Barbosa",
        contact: "+821091519002",
        orderCount: 3,
    }, {
        id: 6,
        name: "Sibabalwe Rubusana",
        contact: "+821091519002",
        orderCount: 3,
    }, {
        id: 7,
        name: "Francisco Maia",
        contact: "+821091519002",
        orderCount: 3,
    }, {
        id: 8,
        name: "Wilhelm Dowall",
        contact: "+821091519002",
        orderCount: 3,
    }, {
        id: 9,
        name: "Ivan Morais",
        contact: "+821091519002",
        orderCount: 3,
    }, {
        id: 10,
        name: "Yvonne Thompson",
        contact: "+821091519002",
        orderCount: 3,
    },
]
export default data;